import loadable from '@loadable/component';
import React, { useState, useCallback } from 'react';
import { apiHolder } from 'api';
import { config } from 'env_def';
const NotificationModal = loadable(() => import('@mail/notification-component').then(module => {
    console.log('module.NotificationModal');
    return module.NotificationModal;
}));
export const useRiskLinkModal = () => {
    const [settings, setSettings] = useState({
        visible: false,
        url: ',',
    });
    const RiskLinkNotificationModal = useCallback(() => {
        const systemApi = apiHolder.api.getSystemApi();
        const source = systemApi.getAppName();
        const webmailHost = config('webMailBJHost');
        const domain = process.env.BUILD_ISELECTRON ? webmailHost : '';
        return (React.createElement(NotificationModal, { domain: domain, source: source, visible: settings.visible, url: settings.url, onVisibleChange: (e) => setSettings(Object.assign(Object.assign({}, settings), { visible: e.detail })) }));
    }, [settings.visible, settings.url]);
    const setRiskUrl = useCallback((url) => {
        setSettings(Object.assign(Object.assign({}, settings), { url, visible: true }));
    }, []);
    return {
        setRiskUrl,
        RiskLinkNotificationModal,
    };
};
